import React, { Component } from 'react'
import t from '../components/Language/language'
import './ViewDetails.css'
import * as languageSettings from '../components/Language/languageSettings'
import _ from 'underscore'
import 'url-search-params-polyfill'
import LeaderboardGroups from '../components/LeaderBoard/LeaderBoardGroups'

var allowedTabs = ["groups","contests","awards", "smacktalk", "feedback"]

class LeaderboardContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
          //Interesting note: showContests page will always be highlighted/ toggled to be active after saving. I am keeping functionality consistent as I change for LB Group.
          selected: allowedTabs[0],
          showGroups:true,
          showContests: false,
          showAwards: false,
          showSmalktalk: false,
          showFeedBack: false,
          saveSuccess: false,
          currentLanguage: languageSettings.getCurrentLanguage(),
        }
        this.tabSelection = this.tabSelection.bind(this)
        this.onSaveSuccess = this.onSaveSuccess.bind(this)
    }

 

  onSaveSuccess(e) {
    this.setState({ selected: allowedTabs[0], saveSuccess: true })
  }

  tabSelection(event) {
    if (event.target.name === 'groups')
    {
        this.setState({ selected: allowedTabs[0], showGroups: true, showContests: false, showAwards: false, showSmalktalk: false, showFeedBack: false })
    }
    /*COMMENTING OUT NEW TABS UNTIL THEIR RESPECTIVE FUNCTIONALITIES ARE READY.
    else if (event.target.name === 'contests') 
    {
      this.setState({ selected: allowedTabs[1], showGroups: false, showContests: true, showAwards: false, showSmalktalk: false, showFeedBack: false })
    } 
    else if (event.target.name === 'awards') 
    {
      this.setState({ selected: allowedTabs[2], showGroups: false, showContests: false, showAwards: true, showSmalktalk: false, showFeedBack: false })
    } else if (event.target.name === 'smacktalk')
    {
      this.setState({ selected: allowedTabs[3], showGroups: false, showContests: false, showAwards: false, showSmalktalk: true, showFeedBack: false })
    }
    else
    {
        this.setState({selected: allowedTabs[4], showGroups: false, showContests: false, showAwards: false, showSmalktalk: false, showFeedBack: true })
    }*/
  }

  render() {
    const language = this.state.currentLanguage

    var page
    const params = new URLSearchParams(this.props.history.location.search);

    if (this.state.showGroups){
        page = <LeaderboardGroups onSaveSuccess={this.onSaveSuccess} saveSuccess={this.state.saveSuccess} />
    }

    return (
      <div className='leaderboards'>
        <div id='Navbar' className='subnav clear'>
          <ul className='subinfo'>
{
            /*COMMENTING OUT NEW TABS UNTIL THEIR RESPECTIVE FUNCTIONALITIES ARE READY.
            <li className={this.state.selected == allowedTabs[0] ? 'active_tab' : ''}><a name='groups' onClick={this.tabSelection} >{t[language].Leaderboards}</a></li>
            <li className={this.state.selected == allowedTabs[1] ? 'active_tab' : ''}><a name='contests' onClick={this.tabSelection} >{t[language].LeaderboardContests}</a></li>
            <li className={this.state.selected == allowedTabs[2] ? 'active_tab' : ''}><a name='awards' onClick={this.tabSelection} >{t[language].LeaderboardAwards}</a></li>
            <li className={this.state.selected == allowedTabs[3] ? 'active_tab' : ''}><a name='smacktalk' onClick={this.tabSelection} >{t[language].LeaderboardSmackTalk}</a></li>
            <li className={this.state.selected == allowedTabs[4] ? 'active_tab' : ''}><a name='feedback' onClick={this.tabSelection} >{t[language].LeaderboardFeedback}</a></li>*/}
          </ul>
        </div>
        {page}
      </div>
    )
  }
}

export default LeaderboardContainer



// WEBPACK FOOTER //
// ./src/containers/LeaderboardContainer.js